import { Component } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { RequisitionStatus } from '@models/matter';
import { MatterDocumentType, MatterFile } from '@models/matter-file';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { FileUploadState } from '@state/file-upload/fileUpload.index';
import { FileUpload } from '@state/file-upload/fileUpload.state';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterUploadedFilesSelectors } from '@state/matter/uploaded-files/matter-uploaded-files.selectors';
import { UploadFileStatus } from '@state/utils/models';
import { Observable } from 'rxjs';
import { ICON } from '@core/util/icon';
import { MatterWordDocumentsDefaultsSource } from '@state/matter/matter-word-documents/matter-word-documents-defaults-source.selectors';
@UntilDestroy()
@Component({
	selector: 'app-response-to-requisitions',
	templateUrl: './response-to-requisitions.component.html',
	styleUrls: ['./response-to-requisitions.component.scss'],
	animations: [openClose()],
	standalone: false,
})
export class ResponseToRequisitionsComponent {
	@Select(FileUploadState.getFileStatus) fileStatusFilter$: Observable<
		(filter: string) => FileUpload
	>;

	@Select(SelectedMatter.useHtmlDocuments)
	public useHtmlDocuments$: Observable<boolean>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@ViewSelectSnapshot(SelectedMatter.requisitionStatus)
	requisitionStatus: RequisitionStatus;
	@ViewSelectSnapshot(SelectedMatter.titleSearchCompletionDate)
	titleSearchCompletionDate: string;
	@ViewSelectSnapshot(MatterUploadedFilesSelectors.getLastestRequisitionFile)
	latestRequisitionFile: MatterFile;
	@ViewSelectSnapshot(SelectedMatter.closingDate) closingDate: string;
	@Select(
		MatterWordDocumentsDefaultsSource.getResponseToRequisitionsSourceIdByMatterType,
	)
	responseToRequisitionsDocSourceIdByMatterType$: Observable<string>;

	public fileUploadStatus: FileUpload;
	public fileUploadStatuses = UploadFileStatus;
	public ICON = ICON;
	public docType = MatterDocumentType.REQUISITION;
	public showDetails = true;
	public fileName: string;

	constructor(private matterDispatch: MatterDispatch) {
		this.fileName = 'Response to requisition';
	}

	setRequisitionRecieved(val: boolean) {
		this.matterDispatch.SetRequisitionStatus(this.matterId, { received: val });
	}

	setRequisitionSent(val: boolean) {
		this.matterDispatch.SetRequisitionStatus(this.matterId, { sent: val });
	}

	setRequisitionDate(date: string) {
		if (!this.closingDate || this.closingDate >= date) {
			this.matterDispatch.Update(this.matterId, {
				titleSearchCompletionDate: date,
			});
		}
	}

	setRequisitionLetterDate(date: string) {
		this.matterDispatch.SetRequisitionStatus(this.matterId, {
			requisitionLetterDate: date,
		});
	}

	setRequisitionStatus() {
		this.matterDispatch.SetRequisitionStatus(
			this.matterId,
			this.requisitionStatus,
		);
	}

	toggleDetails() {
		this.showDetails = !this.showDetails;
	}
}
